import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Wooden garden fence panel: like a wall it runs along the X axis through
// the tile centre, exactly one tile (1 m) long, ~1.0 m high, so consecutive
// fence tiles chain into a continuous run.
const PLANK = "#c8975a";
const POST = "#6b4a2a";

const PICKET_X = [-0.375, -0.225, -0.075, 0.075, 0.225, 0.375];

export const fenceWood = defineModel({
  id: "fence-wood",
  batchId: "modern",
  name: "Wooden fence",
  tags: ["modern", "outdoor", "garden", "fence", "wood"],
  summary: "A wooden picket fence panel, one tile long.",
  description:
    "A wooden garden fence of the Modern Living kit: 1 m long along X, " +
    "~1.0 m high — two bark posts, two horizontal rails and six plank " +
    "pickets. Chain tiles for longer runs; rotate 90 degrees to orient.",
  tiles: { w: 1, h: 1 },
  footprint: 0.7,
  parts(): Part[] {
    const parts: Part[] = [
      // Posts at the tile edges so adjacent panels share a post line.
      { geometry: new THREE.BoxGeometry(0.08, 1.0, 0.08), color: POST, position: [-0.47, 0.5, 0] },
      { geometry: new THREE.BoxGeometry(0.08, 1.0, 0.08), color: POST, position: [0.47, 0.5, 0] },
      // Two horizontal rails.
      { geometry: new THREE.BoxGeometry(1.0, 0.06, 0.04), color: PLANK, position: [0, 0.3, 0.03] },
      { geometry: new THREE.BoxGeometry(1.0, 0.06, 0.04), color: PLANK, position: [0, 0.72, 0.03] },
    ];
    for (const x of PICKET_X) {
      parts.push({
        geometry: new THREE.BoxGeometry(0.09, 0.85, 0.03),
        color: PLANK,
        position: [x, 0.475, 0.065],
      });
    }
    return parts;
  },
  animations: [],
});
